import React from 'react';
import { Col, Row, Button } from 'mdbreact';
import { FormattedMessage, injectIntl } from 'react-intl';

const TableHeader = ({
    showDynamicWeeksButton,
    disableDynamicWeeksButton,
    handleDynamicWeeksClick,
}) => {
    return (
        <Row className="fair-table-header">
            {showDynamicWeeksButton && (
                <Col sm="3">
                    <Button
                        className="btn-main"
                        onClick={handleDynamicWeeksClick}
                        disabled={disableDynamicWeeksButton}
                    >
                        + &nbsp;
                        <FormattedMessage id="fair.dynamic_weeks.add_week_button" />
                    </Button>
                </Col>
            )}
        </Row>
    );
};

export default injectIntl(TableHeader);
